export default __webpack_public_path__ + "static/media/send-message.010cfe3e.svg";